import { default as aboutkFwCyto4RjMeta } from "/app/.app/pages/about.vue?macro=true";
import { default as contactAyC82GJNTXMeta } from "/app/.app/pages/index/contact.vue?macro=true";
import { default as drinkCHxmujXFEFMeta } from "/app/.app/pages/index/drink.vue?macro=true";
import { default as end0pbSEwmLqxMeta } from "/app/.app/pages/index/end.vue?macro=true";
import { default as indexLI062SMWQeMeta } from "/app/.app/pages/index/index.vue?macro=true";
import { default as infosHRiwvVPf8Meta } from "/app/.app/pages/index/info.vue?macro=true";
import { default as locationn572y5MwQ2Meta } from "/app/.app/pages/index/location.vue?macro=true";
import { default as overviewBaMXlgoJGRMeta } from "/app/.app/pages/index/overview.vue?macro=true";
import { default as indexxNJ2T4zPkRMeta } from "/app/.app/pages/index.vue?macro=true";
import { default as _91id_93KU316PVpeUMeta } from "/app/.app/pages/pdf/invoice/[id].vue?macro=true";
import { default as _91id_934Pj6tBeVSWMeta } from "/app/.app/pages/portal/agencies/[id].vue?macro=true";
import { default as indexbPuYJonuQKMeta } from "/app/.app/pages/portal/agencies/index.vue?macro=true";
import { default as new7WlEEFCy0ZMeta } from "/app/.app/pages/portal/agencies/new.vue?macro=true";
import { default as logint1KwPBKurxMeta } from "/app/.app/pages/portal/auth/login.vue?macro=true";
import { default as indexiL6Muo5o5jMeta } from "/app/.app/pages/portal/availabilities/index.vue?macro=true";
import { default as newV8UiMtezsSMeta } from "/app/.app/pages/portal/availabilities/new.vue?macro=true";
import { default as _91id_93KQb4I9dMwQMeta } from "/app/.app/pages/portal/bookings/[id].vue?macro=true";
import { default as _91id_93srbtzB78oYMeta } from "/app/.app/pages/portal/bookings/agency/[id].vue?macro=true";
import { default as newYDDYsG6lMvMeta } from "/app/.app/pages/portal/bookings/agency/new.vue?macro=true";
import { default as indexS2oitQ5MCYMeta } from "/app/.app/pages/portal/bookings/index.vue?macro=true";
import { default as newjwbScQxi82Meta } from "/app/.app/pages/portal/bookings/new.vue?macro=true";
import { default as aboutmlW1q0IpgjMeta } from "/app/.app/pages/portal/cms/about.vue?macro=true";
import { default as faqIm6vFsJrVYMeta } from "/app/.app/pages/portal/cms/faq.vue?macro=true";
import { default as featurescZAaLyc0qIMeta } from "/app/.app/pages/portal/cms/features.vue?macro=true";
import { default as invoices2B8nTReYW6Meta } from "/app/.app/pages/portal/cms/invoices.vue?macro=true";
import { default as priceso6riPc3rcqMeta } from "/app/.app/pages/portal/cms/prices.vue?macro=true";
import { default as testimonialsCFfyKRdqooMeta } from "/app/.app/pages/portal/cms/testimonials.vue?macro=true";
import { default as _91id_934ukxDWfp8qMeta } from "/app/.app/pages/portal/complaints/[id].vue?macro=true";
import { default as indexychXX24tg3Meta } from "/app/.app/pages/portal/complaints/index.vue?macro=true";
import { default as newCSwGIxq6aQMeta } from "/app/.app/pages/portal/complaints/new.vue?macro=true";
import { default as _91id_93AFs1OBtbmGMeta } from "/app/.app/pages/portal/complainttypes/[id].vue?macro=true";
import { default as indexMd8HlgScnDMeta } from "/app/.app/pages/portal/complainttypes/index.vue?macro=true";
import { default as newftdU0KvyBMMeta } from "/app/.app/pages/portal/complainttypes/new.vue?macro=true";
import { default as _91id_93oJAbiHA5mcMeta } from "/app/.app/pages/portal/coupons/[id].vue?macro=true";
import { default as indexNKAt9WvjnrMeta } from "/app/.app/pages/portal/coupons/index.vue?macro=true";
import { default as newBl497b0WqYMeta } from "/app/.app/pages/portal/coupons/new.vue?macro=true";
import { default as _91id_93HqzCqEeYhxMeta } from "/app/.app/pages/portal/damage/[id].vue?macro=true";
import { default as indexJvdGbyW9T3Meta } from "/app/.app/pages/portal/damage/index.vue?macro=true";
import { default as newqJO373j4KdMeta } from "/app/.app/pages/portal/damage/new.vue?macro=true";
import { default as _91id_93lRaQ1gaoXDMeta } from "/app/.app/pages/portal/damages/[id].vue?macro=true";
import { default as indexrRAH3p2CFLMeta } from "/app/.app/pages/portal/damages/index.vue?macro=true";
import { default as new0Iw3R2lgs0Meta } from "/app/.app/pages/portal/damages/new.vue?macro=true";
import { default as _91id_937EFvx2quCHMeta } from "/app/.app/pages/portal/employees/[id].vue?macro=true";
import { default as indexYiIgMOIuaIMeta } from "/app/.app/pages/portal/employees/index.vue?macro=true";
import { default as new5YXYkxOfiXMeta } from "/app/.app/pages/portal/employees/new.vue?macro=true";
import { default as indexBHTcFbzClwMeta } from "/app/.app/pages/portal/index.vue?macro=true";
import { default as _91id_93Iev1lgVDFvMeta } from "/app/.app/pages/portal/invoices/[id].vue?macro=true";
import { default as indexcLQDTZbip0Meta } from "/app/.app/pages/portal/invoices/index.vue?macro=true";
import { default as newrbZkjfyuiOMeta } from "/app/.app/pages/portal/invoices/new.vue?macro=true";
import { default as _91id_93wd6kHF4x6RMeta } from "/app/.app/pages/portal/invoices/view/[id].vue?macro=true";
import { default as _91id_93LEPiQbPomrMeta } from "/app/.app/pages/portal/mycalendar/[id].vue?macro=true";
import { default as absencesFCM56Av9PmMeta } from "/app/.app/pages/portal/mycalendar/absences.vue?macro=true";
import { default as indexwqxIWk5TgWMeta } from "/app/.app/pages/portal/mycalendar/index.vue?macro=true";
import { default as planningaNoLFhdVPbMeta } from "/app/.app/pages/portal/mycalendar/planning.vue?macro=true";
import { default as _91id_93HLSdAYYmHyMeta } from "/app/.app/pages/portal/packages/[id].vue?macro=true";
import { default as _91id_93LzSqYiTpb5Meta } from "/app/.app/pages/portal/packages/drinks/[id].vue?macro=true";
import { default as newpPUu4805oGMeta } from "/app/.app/pages/portal/packages/drinks/new.vue?macro=true";
import { default as indexYdTMWaNnLgMeta } from "/app/.app/pages/portal/packages/index.vue?macro=true";
import { default as _91id_93k45CWYS0NPMeta } from "/app/.app/pages/portal/packages/locations/[id].vue?macro=true";
import { default as newV3xEwcT39EMeta } from "/app/.app/pages/portal/packages/locations/new.vue?macro=true";
import { default as newgoaIiRCXAJMeta } from "/app/.app/pages/portal/packages/new.vue?macro=true";
import { default as index7OODQmviDvMeta } from "/app/.app/pages/portal/packages/pricing/index.vue?macro=true";
import { default as _91id_93JYb4C9aeJSMeta } from "/app/.app/pages/portal/partybikes/[id].vue?macro=true";
import { default as indexh93qfZED4sMeta } from "/app/.app/pages/portal/partybikes/index.vue?macro=true";
import { default as newX7qlJA9yWzMeta } from "/app/.app/pages/portal/partybikes/new.vue?macro=true";
import { default as indexSyafzCy4gDMeta } from "/app/.app/pages/portal/planner/index.vue?macro=true";
import { default as _91id_93Pp7OIAFltEMeta } from "/app/.app/pages/portal/postal/[id].vue?macro=true";
import { default as indexjTmRZ23cHWMeta } from "/app/.app/pages/portal/postal/index.vue?macro=true";
import { default as newIWwRVwZNiXMeta } from "/app/.app/pages/portal/postal/new.vue?macro=true";
import { default as _91id_93ZaotP8mr0lMeta } from "/app/.app/pages/portal/rides/[id].vue?macro=true";
import { default as indexEf6LwPA1ypMeta } from "/app/.app/pages/portal/rides/index.vue?macro=true";
import { default as newoOOFWbRafMMeta } from "/app/.app/pages/portal/rides/new.vue?macro=true";
import { default as tags9HAoLF7gkoMeta } from "/app/.app/pages/portal/settings/tags.vue?macro=true";
import { default as statisticsXXLRAiCSY8Meta } from "/app/.app/pages/portal/statistics.vue?macro=true";
import { default as _91id_93FX8Mi5iTsVMeta } from "/app/.app/pages/portal/towtrucks/[id].vue?macro=true";
import { default as indexO28js6ik5TMeta } from "/app/.app/pages/portal/towtrucks/index.vue?macro=true";
import { default as newCmwphgNA3MMeta } from "/app/.app/pages/portal/towtrucks/new.vue?macro=true";
import { default as _91id_93bmaZG1xCipMeta } from "/app/.app/pages/portal/trailers/[id].vue?macro=true";
import { default as indexjPX3FOAXvIMeta } from "/app/.app/pages/portal/trailers/index.vue?macro=true";
import { default as newuZuUl5VtOjMeta } from "/app/.app/pages/portal/trailers/new.vue?macro=true";
import { default as indexzxoDtLIKuDMeta } from "/app/.app/pages/portal/transport/index.vue?macro=true";
import { default as _91id_93Tc2I0sxqPFMeta } from "/app/.app/pages/portal/users/[id].vue?macro=true";
import { default as indexeuzQPB7LNXMeta } from "/app/.app/pages/portal/users/index.vue?macro=true";
import { default as newLelSdEx4sLMeta } from "/app/.app/pages/portal/users/new.vue?macro=true";
import { default as pricesQi90KJorxuMeta } from "/app/.app/pages/prices.vue?macro=true";
import { default as bobR5ylcTAy2gMeta } from "/app/.app/pages/scheduler/[id]/bob.vue?macro=true";
import { default as index33TqLcbgJ1Meta } from "/app/.app/pages/scheduler/[id]/index.vue?macro=true";
import { default as proposalHkTNv2pdXfMeta } from "/app/.app/pages/scheduler/[id]/proposal.vue?macro=true";
import { default as successiHupaQF8TuMeta } from "/app/.app/pages/scheduler/[id]/success.vue?macro=true";
import { default as _91id_93SDSACHecv7Meta } from "/app/.app/pages/scheduler/[id].vue?macro=true";
import { default as authddXOoYqdewMeta } from "/app/.app/pages/testing/auth.vue?macro=true";
import { default as bobcsw8jbCOsDMeta } from "/app/.app/pages/testing/bob.vue?macro=true";
import { default as bookingnPeCGgjSdRMeta } from "/app/.app/pages/testing/booking.vue?macro=true";
import { default as bookingagencybfDxR3ooXhMeta } from "/app/.app/pages/testing/bookingagency.vue?macro=true";
import { default as calenderentryPyOvRF4So5Meta } from "/app/.app/pages/testing/calenderentry.vue?macro=true";
import { default as calenderentrytypeX3j6yigBSuMeta } from "/app/.app/pages/testing/calenderentrytype.vue?macro=true";
import { default as couponQCLUvFd6LuMeta } from "/app/.app/pages/testing/coupon.vue?macro=true";
import { default as damageHBxpSn47M5Meta } from "/app/.app/pages/testing/damage.vue?macro=true";
import { default as drinksq67it1OyaMMeta } from "/app/.app/pages/testing/drinks.vue?macro=true";
import { default as employeeVjiSxinSfuMeta } from "/app/.app/pages/testing/employee.vue?macro=true";
import { default as package2UHBzkBWFxMeta } from "/app/.app/pages/testing/package.vue?macro=true";
import { default as partybikeNxOnC4fjywMeta } from "/app/.app/pages/testing/partybike.vue?macro=true";
import { default as refuelingck3pGb3jCRMeta } from "/app/.app/pages/testing/refueling.vue?macro=true";
import { default as towtruckCY7NaXfPdIMeta } from "/app/.app/pages/testing/towtruck.vue?macro=true";
import { default as trailer7GCjg3z4GWMeta } from "/app/.app/pages/testing/trailer.vue?macro=true";
import { default as component_45stub02vfHGKSV9Meta } from "/app/node_modules/.pnpm/nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.19.11_db0@0.3.2_eslint@_hs5fzpigcqitedqqy7o6b3beea/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub02vfHGKSV9 } from "/app/node_modules/.pnpm/nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.19.11_db0@0.3.2_eslint@_hs5fzpigcqitedqqy7o6b3beea/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___nl",
    path: "/nl/over-ons",
    meta: aboutkFwCyto4RjMeta || {},
    component: () => import("/app/.app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about-us",
    meta: aboutkFwCyto4RjMeta || {},
    component: () => import("/app/.app/pages/about.vue")
  },
  {
    name: "about___fr",
    path: "/fr/a-propos",
    meta: aboutkFwCyto4RjMeta || {},
    component: () => import("/app/.app/pages/about.vue")
  },
  {
    name: indexxNJ2T4zPkRMeta?.name,
    path: "/nl",
    meta: indexxNJ2T4zPkRMeta || {},
    component: () => import("/app/.app/pages/index.vue"),
    children: [
  {
    name: "index-contact___nl",
    path: "contactinformatie",
    meta: contactAyC82GJNTXMeta || {},
    component: () => import("/app/.app/pages/index/contact.vue")
  },
  {
    name: "index-drink___nl",
    path: "drank",
    meta: drinkCHxmujXFEFMeta || {},
    component: () => import("/app/.app/pages/index/drink.vue")
  },
  {
    name: "index-end___nl",
    path: "end",
    meta: end0pbSEwmLqxMeta || {},
    component: () => import("/app/.app/pages/index/end.vue")
  },
  {
    name: "index___nl",
    path: "",
    meta: indexLI062SMWQeMeta || {},
    component: () => import("/app/.app/pages/index/index.vue")
  },
  {
    name: "index-info___nl",
    path: "wanneer",
    meta: infosHRiwvVPf8Meta || {},
    component: () => import("/app/.app/pages/index/info.vue")
  },
  {
    name: "index-location___nl",
    path: "waar",
    meta: locationn572y5MwQ2Meta || {},
    component: () => import("/app/.app/pages/index/location.vue")
  },
  {
    name: "index-overview___nl",
    path: "overzicht",
    meta: overviewBaMXlgoJGRMeta || {},
    component: () => import("/app/.app/pages/index/overview.vue")
  }
]
  },
  {
    name: indexxNJ2T4zPkRMeta?.name,
    path: "/en",
    meta: indexxNJ2T4zPkRMeta || {},
    component: () => import("/app/.app/pages/index.vue"),
    children: [
  {
    name: "index-contact___en",
    path: "contact-info",
    meta: contactAyC82GJNTXMeta || {},
    component: () => import("/app/.app/pages/index/contact.vue")
  },
  {
    name: "index-drink___en",
    path: "drinks",
    meta: drinkCHxmujXFEFMeta || {},
    component: () => import("/app/.app/pages/index/drink.vue")
  },
  {
    name: "index-end___en",
    path: "end",
    meta: end0pbSEwmLqxMeta || {},
    component: () => import("/app/.app/pages/index/end.vue")
  },
  {
    name: "index___en",
    path: "",
    meta: indexLI062SMWQeMeta || {},
    component: () => import("/app/.app/pages/index/index.vue")
  },
  {
    name: "index-info___en",
    path: "when",
    meta: infosHRiwvVPf8Meta || {},
    component: () => import("/app/.app/pages/index/info.vue")
  },
  {
    name: "index-location___en",
    path: "where",
    meta: locationn572y5MwQ2Meta || {},
    component: () => import("/app/.app/pages/index/location.vue")
  },
  {
    name: "index-overview___en",
    path: "overview",
    meta: overviewBaMXlgoJGRMeta || {},
    component: () => import("/app/.app/pages/index/overview.vue")
  }
]
  },
  {
    name: indexxNJ2T4zPkRMeta?.name,
    path: "/fr",
    meta: indexxNJ2T4zPkRMeta || {},
    component: () => import("/app/.app/pages/index.vue"),
    children: [
  {
    name: "index-contact___fr",
    path: "informations-de-contact",
    meta: contactAyC82GJNTXMeta || {},
    component: () => import("/app/.app/pages/index/contact.vue")
  },
  {
    name: "index-drink___fr",
    path: "boissons",
    meta: drinkCHxmujXFEFMeta || {},
    component: () => import("/app/.app/pages/index/drink.vue")
  },
  {
    name: "index-end___fr",
    path: "end",
    meta: end0pbSEwmLqxMeta || {},
    component: () => import("/app/.app/pages/index/end.vue")
  },
  {
    name: "index___fr",
    path: "",
    meta: indexLI062SMWQeMeta || {},
    component: () => import("/app/.app/pages/index/index.vue")
  },
  {
    name: "index-info___fr",
    path: "quand",
    meta: infosHRiwvVPf8Meta || {},
    component: () => import("/app/.app/pages/index/info.vue")
  },
  {
    name: "index-location___fr",
    path: "ou",
    meta: locationn572y5MwQ2Meta || {},
    component: () => import("/app/.app/pages/index/location.vue")
  },
  {
    name: "index-overview___fr",
    path: "aper%C3%A7u",
    meta: overviewBaMXlgoJGRMeta || {},
    component: () => import("/app/.app/pages/index/overview.vue")
  }
]
  },
  {
    name: "pdf-invoice-id___nl",
    path: "/nl/pdf/invoice/:id()",
    meta: _91id_93KU316PVpeUMeta || {},
    component: () => import("/app/.app/pages/pdf/invoice/[id].vue")
  },
  {
    name: "pdf-invoice-id___en",
    path: "/en/pdf/invoice/:id()",
    meta: _91id_93KU316PVpeUMeta || {},
    component: () => import("/app/.app/pages/pdf/invoice/[id].vue")
  },
  {
    name: "pdf-invoice-id___fr",
    path: "/fr/pdf/invoice/:id()",
    meta: _91id_93KU316PVpeUMeta || {},
    component: () => import("/app/.app/pages/pdf/invoice/[id].vue")
  },
  {
    name: "portal-agencies-id___nl",
    path: "/nl/portal/agencies/:id()",
    meta: _91id_934Pj6tBeVSWMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/[id].vue")
  },
  {
    name: "portal-agencies-id___en",
    path: "/en/portal/agencies/:id()",
    meta: _91id_934Pj6tBeVSWMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/[id].vue")
  },
  {
    name: "portal-agencies-id___fr",
    path: "/fr/portal/agencies/:id()",
    meta: _91id_934Pj6tBeVSWMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/[id].vue")
  },
  {
    name: "portal-agencies___nl",
    path: "/nl/portal/agencies",
    meta: indexbPuYJonuQKMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/index.vue")
  },
  {
    name: "portal-agencies___en",
    path: "/en/portal/agencies",
    meta: indexbPuYJonuQKMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/index.vue")
  },
  {
    name: "portal-agencies___fr",
    path: "/fr/portal/agencies",
    meta: indexbPuYJonuQKMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/index.vue")
  },
  {
    name: "portal-agencies-new___nl",
    path: "/nl/portal/agencies/new",
    meta: new7WlEEFCy0ZMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/new.vue")
  },
  {
    name: "portal-agencies-new___en",
    path: "/en/portal/agencies/new",
    meta: new7WlEEFCy0ZMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/new.vue")
  },
  {
    name: "portal-agencies-new___fr",
    path: "/fr/portal/agencies/new",
    meta: new7WlEEFCy0ZMeta || {},
    component: () => import("/app/.app/pages/portal/agencies/new.vue")
  },
  {
    name: "portal-auth-login___nl",
    path: "/nl/portal/auth/login",
    meta: logint1KwPBKurxMeta || {},
    component: () => import("/app/.app/pages/portal/auth/login.vue")
  },
  {
    name: "portal-auth-login___en",
    path: "/en/portal/auth/login",
    meta: logint1KwPBKurxMeta || {},
    component: () => import("/app/.app/pages/portal/auth/login.vue")
  },
  {
    name: "portal-auth-login___fr",
    path: "/fr/portal/auth/login",
    meta: logint1KwPBKurxMeta || {},
    component: () => import("/app/.app/pages/portal/auth/login.vue")
  },
  {
    name: "portal-availabilities___nl",
    path: "/nl/portal/availabilities",
    meta: indexiL6Muo5o5jMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/index.vue")
  },
  {
    name: "portal-availabilities___en",
    path: "/en/portal/availabilities",
    meta: indexiL6Muo5o5jMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/index.vue")
  },
  {
    name: "portal-availabilities___fr",
    path: "/fr/portal/availabilities",
    meta: indexiL6Muo5o5jMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/index.vue")
  },
  {
    name: "portal-availabilities-new___nl",
    path: "/nl/portal/availabilities/new",
    meta: newV8UiMtezsSMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/new.vue")
  },
  {
    name: "portal-availabilities-new___en",
    path: "/en/portal/availabilities/new",
    meta: newV8UiMtezsSMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/new.vue")
  },
  {
    name: "portal-availabilities-new___fr",
    path: "/fr/portal/availabilities/new",
    meta: newV8UiMtezsSMeta || {},
    component: () => import("/app/.app/pages/portal/availabilities/new.vue")
  },
  {
    name: "portal-bookings-id___nl",
    path: "/nl/portal/bookings/:id()",
    meta: _91id_93KQb4I9dMwQMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/[id].vue")
  },
  {
    name: "portal-bookings-id___en",
    path: "/en/portal/bookings/:id()",
    meta: _91id_93KQb4I9dMwQMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/[id].vue")
  },
  {
    name: "portal-bookings-id___fr",
    path: "/fr/portal/bookings/:id()",
    meta: _91id_93KQb4I9dMwQMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/[id].vue")
  },
  {
    name: "portal-bookings-agency-id___nl",
    path: "/nl/portal/bookings/agency/:id()",
    meta: _91id_93srbtzB78oYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/[id].vue")
  },
  {
    name: "portal-bookings-agency-id___en",
    path: "/en/portal/bookings/agency/:id()",
    meta: _91id_93srbtzB78oYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/[id].vue")
  },
  {
    name: "portal-bookings-agency-id___fr",
    path: "/fr/portal/bookings/agency/:id()",
    meta: _91id_93srbtzB78oYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/[id].vue")
  },
  {
    name: "portal-bookings-agency-new___nl",
    path: "/nl/portal/bookings/agency/new",
    meta: newYDDYsG6lMvMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/new.vue")
  },
  {
    name: "portal-bookings-agency-new___en",
    path: "/en/portal/bookings/agency/new",
    meta: newYDDYsG6lMvMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/new.vue")
  },
  {
    name: "portal-bookings-agency-new___fr",
    path: "/fr/portal/bookings/agency/new",
    meta: newYDDYsG6lMvMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/agency/new.vue")
  },
  {
    name: "portal-bookings___nl",
    path: "/nl/portal/bookings",
    meta: indexS2oitQ5MCYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/index.vue")
  },
  {
    name: "portal-bookings___en",
    path: "/en/portal/bookings",
    meta: indexS2oitQ5MCYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/index.vue")
  },
  {
    name: "portal-bookings___fr",
    path: "/fr/portal/bookings",
    meta: indexS2oitQ5MCYMeta || {},
    component: () => import("/app/.app/pages/portal/bookings/index.vue")
  },
  {
    name: "portal-bookings-new___nl",
    path: "/nl/portal/bookings/new",
    meta: newjwbScQxi82Meta || {},
    component: () => import("/app/.app/pages/portal/bookings/new.vue")
  },
  {
    name: "portal-bookings-new___en",
    path: "/en/portal/bookings/new",
    meta: newjwbScQxi82Meta || {},
    component: () => import("/app/.app/pages/portal/bookings/new.vue")
  },
  {
    name: "portal-bookings-new___fr",
    path: "/fr/portal/bookings/new",
    meta: newjwbScQxi82Meta || {},
    component: () => import("/app/.app/pages/portal/bookings/new.vue")
  },
  {
    name: "portal-cms-about___nl",
    path: "/nl/portal/cms/about",
    meta: aboutmlW1q0IpgjMeta || {},
    component: () => import("/app/.app/pages/portal/cms/about.vue")
  },
  {
    name: "portal-cms-about___en",
    path: "/en/portal/cms/about",
    meta: aboutmlW1q0IpgjMeta || {},
    component: () => import("/app/.app/pages/portal/cms/about.vue")
  },
  {
    name: "portal-cms-about___fr",
    path: "/fr/portal/cms/about",
    meta: aboutmlW1q0IpgjMeta || {},
    component: () => import("/app/.app/pages/portal/cms/about.vue")
  },
  {
    name: "portal-cms-faq___nl",
    path: "/nl/portal/cms/faq",
    meta: faqIm6vFsJrVYMeta || {},
    component: () => import("/app/.app/pages/portal/cms/faq.vue")
  },
  {
    name: "portal-cms-faq___en",
    path: "/en/portal/cms/faq",
    meta: faqIm6vFsJrVYMeta || {},
    component: () => import("/app/.app/pages/portal/cms/faq.vue")
  },
  {
    name: "portal-cms-faq___fr",
    path: "/fr/portal/cms/faq",
    meta: faqIm6vFsJrVYMeta || {},
    component: () => import("/app/.app/pages/portal/cms/faq.vue")
  },
  {
    name: "portal-cms-features___nl",
    path: "/nl/portal/cms/features",
    meta: featurescZAaLyc0qIMeta || {},
    component: () => import("/app/.app/pages/portal/cms/features.vue")
  },
  {
    name: "portal-cms-features___en",
    path: "/en/portal/cms/features",
    meta: featurescZAaLyc0qIMeta || {},
    component: () => import("/app/.app/pages/portal/cms/features.vue")
  },
  {
    name: "portal-cms-features___fr",
    path: "/fr/portal/cms/features",
    meta: featurescZAaLyc0qIMeta || {},
    component: () => import("/app/.app/pages/portal/cms/features.vue")
  },
  {
    name: "portal-cms-invoices___nl",
    path: "/nl/portal/cms/invoices",
    meta: invoices2B8nTReYW6Meta || {},
    component: () => import("/app/.app/pages/portal/cms/invoices.vue")
  },
  {
    name: "portal-cms-invoices___en",
    path: "/en/portal/cms/invoices",
    meta: invoices2B8nTReYW6Meta || {},
    component: () => import("/app/.app/pages/portal/cms/invoices.vue")
  },
  {
    name: "portal-cms-invoices___fr",
    path: "/fr/portal/cms/invoices",
    meta: invoices2B8nTReYW6Meta || {},
    component: () => import("/app/.app/pages/portal/cms/invoices.vue")
  },
  {
    name: "portal-cms-prices___nl",
    path: "/nl/portal/cms/prices",
    meta: priceso6riPc3rcqMeta || {},
    component: () => import("/app/.app/pages/portal/cms/prices.vue")
  },
  {
    name: "portal-cms-prices___en",
    path: "/en/portal/cms/prices",
    meta: priceso6riPc3rcqMeta || {},
    component: () => import("/app/.app/pages/portal/cms/prices.vue")
  },
  {
    name: "portal-cms-prices___fr",
    path: "/fr/portal/cms/prices",
    meta: priceso6riPc3rcqMeta || {},
    component: () => import("/app/.app/pages/portal/cms/prices.vue")
  },
  {
    name: "portal-cms-testimonials___nl",
    path: "/nl/portal/cms/testimonials",
    meta: testimonialsCFfyKRdqooMeta || {},
    component: () => import("/app/.app/pages/portal/cms/testimonials.vue")
  },
  {
    name: "portal-cms-testimonials___en",
    path: "/en/portal/cms/testimonials",
    meta: testimonialsCFfyKRdqooMeta || {},
    component: () => import("/app/.app/pages/portal/cms/testimonials.vue")
  },
  {
    name: "portal-cms-testimonials___fr",
    path: "/fr/portal/cms/testimonials",
    meta: testimonialsCFfyKRdqooMeta || {},
    component: () => import("/app/.app/pages/portal/cms/testimonials.vue")
  },
  {
    name: "portal-complaints-id___nl",
    path: "/nl/portal/complaints/:id()",
    meta: _91id_934ukxDWfp8qMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/[id].vue")
  },
  {
    name: "portal-complaints-id___en",
    path: "/en/portal/complaints/:id()",
    meta: _91id_934ukxDWfp8qMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/[id].vue")
  },
  {
    name: "portal-complaints-id___fr",
    path: "/fr/portal/complaints/:id()",
    meta: _91id_934ukxDWfp8qMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/[id].vue")
  },
  {
    name: "portal-complaints___nl",
    path: "/nl/portal/complaints",
    meta: indexychXX24tg3Meta || {},
    component: () => import("/app/.app/pages/portal/complaints/index.vue")
  },
  {
    name: "portal-complaints___en",
    path: "/en/portal/complaints",
    meta: indexychXX24tg3Meta || {},
    component: () => import("/app/.app/pages/portal/complaints/index.vue")
  },
  {
    name: "portal-complaints___fr",
    path: "/fr/portal/complaints",
    meta: indexychXX24tg3Meta || {},
    component: () => import("/app/.app/pages/portal/complaints/index.vue")
  },
  {
    name: "portal-complaints-new___nl",
    path: "/nl/portal/complaints/new",
    meta: newCSwGIxq6aQMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/new.vue")
  },
  {
    name: "portal-complaints-new___en",
    path: "/en/portal/complaints/new",
    meta: newCSwGIxq6aQMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/new.vue")
  },
  {
    name: "portal-complaints-new___fr",
    path: "/fr/portal/complaints/new",
    meta: newCSwGIxq6aQMeta || {},
    component: () => import("/app/.app/pages/portal/complaints/new.vue")
  },
  {
    name: "portal-complainttypes-id___nl",
    path: "/nl/portal/complainttypes/:id()",
    meta: _91id_93AFs1OBtbmGMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/[id].vue")
  },
  {
    name: "portal-complainttypes-id___en",
    path: "/en/portal/complainttypes/:id()",
    meta: _91id_93AFs1OBtbmGMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/[id].vue")
  },
  {
    name: "portal-complainttypes-id___fr",
    path: "/fr/portal/complainttypes/:id()",
    meta: _91id_93AFs1OBtbmGMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/[id].vue")
  },
  {
    name: "portal-complainttypes___nl",
    path: "/nl/portal/complainttypes",
    meta: indexMd8HlgScnDMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/index.vue")
  },
  {
    name: "portal-complainttypes___en",
    path: "/en/portal/complainttypes",
    meta: indexMd8HlgScnDMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/index.vue")
  },
  {
    name: "portal-complainttypes___fr",
    path: "/fr/portal/complainttypes",
    meta: indexMd8HlgScnDMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/index.vue")
  },
  {
    name: "portal-complainttypes-new___nl",
    path: "/nl/portal/complainttypes/new",
    meta: newftdU0KvyBMMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/new.vue")
  },
  {
    name: "portal-complainttypes-new___en",
    path: "/en/portal/complainttypes/new",
    meta: newftdU0KvyBMMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/new.vue")
  },
  {
    name: "portal-complainttypes-new___fr",
    path: "/fr/portal/complainttypes/new",
    meta: newftdU0KvyBMMeta || {},
    component: () => import("/app/.app/pages/portal/complainttypes/new.vue")
  },
  {
    name: "portal-coupons-id___nl",
    path: "/nl/portal/coupons/:id()",
    meta: _91id_93oJAbiHA5mcMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/[id].vue")
  },
  {
    name: "portal-coupons-id___en",
    path: "/en/portal/coupons/:id()",
    meta: _91id_93oJAbiHA5mcMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/[id].vue")
  },
  {
    name: "portal-coupons-id___fr",
    path: "/fr/portal/coupons/:id()",
    meta: _91id_93oJAbiHA5mcMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/[id].vue")
  },
  {
    name: "portal-coupons___nl",
    path: "/nl/portal/coupons",
    meta: indexNKAt9WvjnrMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/index.vue")
  },
  {
    name: "portal-coupons___en",
    path: "/en/portal/coupons",
    meta: indexNKAt9WvjnrMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/index.vue")
  },
  {
    name: "portal-coupons___fr",
    path: "/fr/portal/coupons",
    meta: indexNKAt9WvjnrMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/index.vue")
  },
  {
    name: "portal-coupons-new___nl",
    path: "/nl/portal/coupons/new",
    meta: newBl497b0WqYMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/new.vue")
  },
  {
    name: "portal-coupons-new___en",
    path: "/en/portal/coupons/new",
    meta: newBl497b0WqYMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/new.vue")
  },
  {
    name: "portal-coupons-new___fr",
    path: "/fr/portal/coupons/new",
    meta: newBl497b0WqYMeta || {},
    component: () => import("/app/.app/pages/portal/coupons/new.vue")
  },
  {
    name: "portal-damage-id___nl",
    path: "/nl/portal/damage/:id()",
    meta: _91id_93HqzCqEeYhxMeta || {},
    component: () => import("/app/.app/pages/portal/damage/[id].vue")
  },
  {
    name: "portal-damage-id___en",
    path: "/en/portal/damage/:id()",
    meta: _91id_93HqzCqEeYhxMeta || {},
    component: () => import("/app/.app/pages/portal/damage/[id].vue")
  },
  {
    name: "portal-damage-id___fr",
    path: "/fr/portal/damage/:id()",
    meta: _91id_93HqzCqEeYhxMeta || {},
    component: () => import("/app/.app/pages/portal/damage/[id].vue")
  },
  {
    name: "portal-damage___nl",
    path: "/nl/portal/damage",
    meta: indexJvdGbyW9T3Meta || {},
    component: () => import("/app/.app/pages/portal/damage/index.vue")
  },
  {
    name: "portal-damage___en",
    path: "/en/portal/damage",
    meta: indexJvdGbyW9T3Meta || {},
    component: () => import("/app/.app/pages/portal/damage/index.vue")
  },
  {
    name: "portal-damage___fr",
    path: "/fr/portal/damage",
    meta: indexJvdGbyW9T3Meta || {},
    component: () => import("/app/.app/pages/portal/damage/index.vue")
  },
  {
    name: "portal-damage-new___nl",
    path: "/nl/portal/damage/new",
    meta: newqJO373j4KdMeta || {},
    component: () => import("/app/.app/pages/portal/damage/new.vue")
  },
  {
    name: "portal-damage-new___en",
    path: "/en/portal/damage/new",
    meta: newqJO373j4KdMeta || {},
    component: () => import("/app/.app/pages/portal/damage/new.vue")
  },
  {
    name: "portal-damage-new___fr",
    path: "/fr/portal/damage/new",
    meta: newqJO373j4KdMeta || {},
    component: () => import("/app/.app/pages/portal/damage/new.vue")
  },
  {
    name: "portal-damages-id___nl",
    path: "/nl/portal/damages/:id()",
    meta: _91id_93lRaQ1gaoXDMeta || {},
    component: () => import("/app/.app/pages/portal/damages/[id].vue")
  },
  {
    name: "portal-damages-id___en",
    path: "/en/portal/damages/:id()",
    meta: _91id_93lRaQ1gaoXDMeta || {},
    component: () => import("/app/.app/pages/portal/damages/[id].vue")
  },
  {
    name: "portal-damages-id___fr",
    path: "/fr/portal/damages/:id()",
    meta: _91id_93lRaQ1gaoXDMeta || {},
    component: () => import("/app/.app/pages/portal/damages/[id].vue")
  },
  {
    name: "portal-damages___nl",
    path: "/nl/portal/damages",
    meta: indexrRAH3p2CFLMeta || {},
    component: () => import("/app/.app/pages/portal/damages/index.vue")
  },
  {
    name: "portal-damages___en",
    path: "/en/portal/damages",
    meta: indexrRAH3p2CFLMeta || {},
    component: () => import("/app/.app/pages/portal/damages/index.vue")
  },
  {
    name: "portal-damages___fr",
    path: "/fr/portal/damages",
    meta: indexrRAH3p2CFLMeta || {},
    component: () => import("/app/.app/pages/portal/damages/index.vue")
  },
  {
    name: "portal-damages-new___nl",
    path: "/nl/portal/damages/new",
    meta: new0Iw3R2lgs0Meta || {},
    component: () => import("/app/.app/pages/portal/damages/new.vue")
  },
  {
    name: "portal-damages-new___en",
    path: "/en/portal/damages/new",
    meta: new0Iw3R2lgs0Meta || {},
    component: () => import("/app/.app/pages/portal/damages/new.vue")
  },
  {
    name: "portal-damages-new___fr",
    path: "/fr/portal/damages/new",
    meta: new0Iw3R2lgs0Meta || {},
    component: () => import("/app/.app/pages/portal/damages/new.vue")
  },
  {
    name: "portal-employees-id___nl",
    path: "/nl/portal/employees/:id()",
    meta: _91id_937EFvx2quCHMeta || {},
    component: () => import("/app/.app/pages/portal/employees/[id].vue")
  },
  {
    name: "portal-employees-id___en",
    path: "/en/portal/employees/:id()",
    meta: _91id_937EFvx2quCHMeta || {},
    component: () => import("/app/.app/pages/portal/employees/[id].vue")
  },
  {
    name: "portal-employees-id___fr",
    path: "/fr/portal/employees/:id()",
    meta: _91id_937EFvx2quCHMeta || {},
    component: () => import("/app/.app/pages/portal/employees/[id].vue")
  },
  {
    name: "portal-employees___nl",
    path: "/nl/portal/employees",
    meta: indexYiIgMOIuaIMeta || {},
    component: () => import("/app/.app/pages/portal/employees/index.vue")
  },
  {
    name: "portal-employees___en",
    path: "/en/portal/employees",
    meta: indexYiIgMOIuaIMeta || {},
    component: () => import("/app/.app/pages/portal/employees/index.vue")
  },
  {
    name: "portal-employees___fr",
    path: "/fr/portal/employees",
    meta: indexYiIgMOIuaIMeta || {},
    component: () => import("/app/.app/pages/portal/employees/index.vue")
  },
  {
    name: "portal-employees-new___nl",
    path: "/nl/portal/employees/new",
    meta: new5YXYkxOfiXMeta || {},
    component: () => import("/app/.app/pages/portal/employees/new.vue")
  },
  {
    name: "portal-employees-new___en",
    path: "/en/portal/employees/new",
    meta: new5YXYkxOfiXMeta || {},
    component: () => import("/app/.app/pages/portal/employees/new.vue")
  },
  {
    name: "portal-employees-new___fr",
    path: "/fr/portal/employees/new",
    meta: new5YXYkxOfiXMeta || {},
    component: () => import("/app/.app/pages/portal/employees/new.vue")
  },
  {
    name: "portal___nl",
    path: "/nl/portal",
    meta: indexBHTcFbzClwMeta || {},
    component: () => import("/app/.app/pages/portal/index.vue")
  },
  {
    name: "portal___en",
    path: "/en/portal",
    meta: indexBHTcFbzClwMeta || {},
    component: () => import("/app/.app/pages/portal/index.vue")
  },
  {
    name: "portal___fr",
    path: "/fr/portal",
    meta: indexBHTcFbzClwMeta || {},
    component: () => import("/app/.app/pages/portal/index.vue")
  },
  {
    name: "portal-invoices-id___nl",
    path: "/nl/portal/invoices/:id()",
    meta: _91id_93Iev1lgVDFvMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/[id].vue")
  },
  {
    name: "portal-invoices-id___en",
    path: "/en/portal/invoices/:id()",
    meta: _91id_93Iev1lgVDFvMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/[id].vue")
  },
  {
    name: "portal-invoices-id___fr",
    path: "/fr/portal/invoices/:id()",
    meta: _91id_93Iev1lgVDFvMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/[id].vue")
  },
  {
    name: "portal-invoices___nl",
    path: "/nl/portal/invoices",
    meta: indexcLQDTZbip0Meta || {},
    component: () => import("/app/.app/pages/portal/invoices/index.vue")
  },
  {
    name: "portal-invoices___en",
    path: "/en/portal/invoices",
    meta: indexcLQDTZbip0Meta || {},
    component: () => import("/app/.app/pages/portal/invoices/index.vue")
  },
  {
    name: "portal-invoices___fr",
    path: "/fr/portal/invoices",
    meta: indexcLQDTZbip0Meta || {},
    component: () => import("/app/.app/pages/portal/invoices/index.vue")
  },
  {
    name: "portal-invoices-new___nl",
    path: "/nl/portal/invoices/new",
    meta: newrbZkjfyuiOMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/new.vue")
  },
  {
    name: "portal-invoices-new___en",
    path: "/en/portal/invoices/new",
    meta: newrbZkjfyuiOMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/new.vue")
  },
  {
    name: "portal-invoices-new___fr",
    path: "/fr/portal/invoices/new",
    meta: newrbZkjfyuiOMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/new.vue")
  },
  {
    name: "portal-invoices-view-id___nl",
    path: "/nl/portal/invoices/view/:id()",
    meta: _91id_93wd6kHF4x6RMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/view/[id].vue")
  },
  {
    name: "portal-invoices-view-id___en",
    path: "/en/portal/invoices/view/:id()",
    meta: _91id_93wd6kHF4x6RMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/view/[id].vue")
  },
  {
    name: "portal-invoices-view-id___fr",
    path: "/fr/portal/invoices/view/:id()",
    meta: _91id_93wd6kHF4x6RMeta || {},
    component: () => import("/app/.app/pages/portal/invoices/view/[id].vue")
  },
  {
    name: "portal-mycalendar-id___nl",
    path: "/nl/portal/mycalendar/:id()",
    meta: _91id_93LEPiQbPomrMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/[id].vue")
  },
  {
    name: "portal-mycalendar-id___en",
    path: "/en/portal/mycalendar/:id()",
    meta: _91id_93LEPiQbPomrMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/[id].vue")
  },
  {
    name: "portal-mycalendar-id___fr",
    path: "/fr/portal/mycalendar/:id()",
    meta: _91id_93LEPiQbPomrMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/[id].vue")
  },
  {
    name: "portal-mycalendar-absences___nl",
    path: "/nl/portal/mycalendar/absences",
    meta: absencesFCM56Av9PmMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/absences.vue")
  },
  {
    name: "portal-mycalendar-absences___en",
    path: "/en/portal/mycalendar/absences",
    meta: absencesFCM56Av9PmMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/absences.vue")
  },
  {
    name: "portal-mycalendar-absences___fr",
    path: "/fr/portal/mycalendar/absences",
    meta: absencesFCM56Av9PmMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/absences.vue")
  },
  {
    name: "portal-mycalendar___nl",
    path: "/nl/portal/mycalendar",
    meta: indexwqxIWk5TgWMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/index.vue")
  },
  {
    name: "portal-mycalendar___en",
    path: "/en/portal/mycalendar",
    meta: indexwqxIWk5TgWMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/index.vue")
  },
  {
    name: "portal-mycalendar___fr",
    path: "/fr/portal/mycalendar",
    meta: indexwqxIWk5TgWMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/index.vue")
  },
  {
    name: "portal-mycalendar-planning___nl",
    path: "/nl/portal/mycalendar/planning",
    meta: planningaNoLFhdVPbMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/planning.vue")
  },
  {
    name: "portal-mycalendar-planning___en",
    path: "/en/portal/mycalendar/planning",
    meta: planningaNoLFhdVPbMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/planning.vue")
  },
  {
    name: "portal-mycalendar-planning___fr",
    path: "/fr/portal/mycalendar/planning",
    meta: planningaNoLFhdVPbMeta || {},
    component: () => import("/app/.app/pages/portal/mycalendar/planning.vue")
  },
  {
    name: "portal-packages-id___nl",
    path: "/nl/portal/packages/:id()",
    meta: _91id_93HLSdAYYmHyMeta || {},
    component: () => import("/app/.app/pages/portal/packages/[id].vue")
  },
  {
    name: "portal-packages-id___en",
    path: "/en/portal/packages/:id()",
    meta: _91id_93HLSdAYYmHyMeta || {},
    component: () => import("/app/.app/pages/portal/packages/[id].vue")
  },
  {
    name: "portal-packages-id___fr",
    path: "/fr/portal/packages/:id()",
    meta: _91id_93HLSdAYYmHyMeta || {},
    component: () => import("/app/.app/pages/portal/packages/[id].vue")
  },
  {
    name: "portal-packages-drinks-id___nl",
    path: "/nl/portal/packages/drinks/:id()",
    meta: _91id_93LzSqYiTpb5Meta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/[id].vue")
  },
  {
    name: "portal-packages-drinks-id___en",
    path: "/en/portal/packages/drinks/:id()",
    meta: _91id_93LzSqYiTpb5Meta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/[id].vue")
  },
  {
    name: "portal-packages-drinks-id___fr",
    path: "/fr/portal/packages/drinks/:id()",
    meta: _91id_93LzSqYiTpb5Meta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/[id].vue")
  },
  {
    name: "portal-packages-drinks-new___nl",
    path: "/nl/portal/packages/drinks/new",
    meta: newpPUu4805oGMeta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/new.vue")
  },
  {
    name: "portal-packages-drinks-new___en",
    path: "/en/portal/packages/drinks/new",
    meta: newpPUu4805oGMeta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/new.vue")
  },
  {
    name: "portal-packages-drinks-new___fr",
    path: "/fr/portal/packages/drinks/new",
    meta: newpPUu4805oGMeta || {},
    component: () => import("/app/.app/pages/portal/packages/drinks/new.vue")
  },
  {
    name: "portal-packages___nl",
    path: "/nl/portal/packages",
    meta: indexYdTMWaNnLgMeta || {},
    component: () => import("/app/.app/pages/portal/packages/index.vue")
  },
  {
    name: "portal-packages___en",
    path: "/en/portal/packages",
    meta: indexYdTMWaNnLgMeta || {},
    component: () => import("/app/.app/pages/portal/packages/index.vue")
  },
  {
    name: "portal-packages___fr",
    path: "/fr/portal/packages",
    meta: indexYdTMWaNnLgMeta || {},
    component: () => import("/app/.app/pages/portal/packages/index.vue")
  },
  {
    name: "portal-packages-locations-id___nl",
    path: "/nl/portal/packages/locations/:id()",
    meta: _91id_93k45CWYS0NPMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/[id].vue")
  },
  {
    name: "portal-packages-locations-id___en",
    path: "/en/portal/packages/locations/:id()",
    meta: _91id_93k45CWYS0NPMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/[id].vue")
  },
  {
    name: "portal-packages-locations-id___fr",
    path: "/fr/portal/packages/locations/:id()",
    meta: _91id_93k45CWYS0NPMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/[id].vue")
  },
  {
    name: "portal-packages-locations-new___nl",
    path: "/nl/portal/packages/locations/new",
    meta: newV3xEwcT39EMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/new.vue")
  },
  {
    name: "portal-packages-locations-new___en",
    path: "/en/portal/packages/locations/new",
    meta: newV3xEwcT39EMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/new.vue")
  },
  {
    name: "portal-packages-locations-new___fr",
    path: "/fr/portal/packages/locations/new",
    meta: newV3xEwcT39EMeta || {},
    component: () => import("/app/.app/pages/portal/packages/locations/new.vue")
  },
  {
    name: "portal-packages-new___nl",
    path: "/nl/portal/packages/new",
    meta: newgoaIiRCXAJMeta || {},
    component: () => import("/app/.app/pages/portal/packages/new.vue")
  },
  {
    name: "portal-packages-new___en",
    path: "/en/portal/packages/new",
    meta: newgoaIiRCXAJMeta || {},
    component: () => import("/app/.app/pages/portal/packages/new.vue")
  },
  {
    name: "portal-packages-new___fr",
    path: "/fr/portal/packages/new",
    meta: newgoaIiRCXAJMeta || {},
    component: () => import("/app/.app/pages/portal/packages/new.vue")
  },
  {
    name: "portal-packages-pricing___nl",
    path: "/nl/portal/packages/pricing",
    meta: index7OODQmviDvMeta || {},
    component: () => import("/app/.app/pages/portal/packages/pricing/index.vue")
  },
  {
    name: "portal-packages-pricing___en",
    path: "/en/portal/packages/pricing",
    meta: index7OODQmviDvMeta || {},
    component: () => import("/app/.app/pages/portal/packages/pricing/index.vue")
  },
  {
    name: "portal-packages-pricing___fr",
    path: "/fr/portal/packages/pricing",
    meta: index7OODQmviDvMeta || {},
    component: () => import("/app/.app/pages/portal/packages/pricing/index.vue")
  },
  {
    name: "portal-partybikes-id___nl",
    path: "/nl/portal/partybikes/:id()",
    meta: _91id_93JYb4C9aeJSMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/[id].vue")
  },
  {
    name: "portal-partybikes-id___en",
    path: "/en/portal/partybikes/:id()",
    meta: _91id_93JYb4C9aeJSMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/[id].vue")
  },
  {
    name: "portal-partybikes-id___fr",
    path: "/fr/portal/partybikes/:id()",
    meta: _91id_93JYb4C9aeJSMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/[id].vue")
  },
  {
    name: "portal-partybikes___nl",
    path: "/nl/portal/partybikes",
    meta: indexh93qfZED4sMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/index.vue")
  },
  {
    name: "portal-partybikes___en",
    path: "/en/portal/partybikes",
    meta: indexh93qfZED4sMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/index.vue")
  },
  {
    name: "portal-partybikes___fr",
    path: "/fr/portal/partybikes",
    meta: indexh93qfZED4sMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/index.vue")
  },
  {
    name: "portal-partybikes-new___nl",
    path: "/nl/portal/partybikes/new",
    meta: newX7qlJA9yWzMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/new.vue")
  },
  {
    name: "portal-partybikes-new___en",
    path: "/en/portal/partybikes/new",
    meta: newX7qlJA9yWzMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/new.vue")
  },
  {
    name: "portal-partybikes-new___fr",
    path: "/fr/portal/partybikes/new",
    meta: newX7qlJA9yWzMeta || {},
    component: () => import("/app/.app/pages/portal/partybikes/new.vue")
  },
  {
    name: "portal-planner___nl",
    path: "/nl/portal/planner",
    meta: indexSyafzCy4gDMeta || {},
    component: () => import("/app/.app/pages/portal/planner/index.vue")
  },
  {
    name: "portal-planner___en",
    path: "/en/portal/planner",
    meta: indexSyafzCy4gDMeta || {},
    component: () => import("/app/.app/pages/portal/planner/index.vue")
  },
  {
    name: "portal-planner___fr",
    path: "/fr/portal/planner",
    meta: indexSyafzCy4gDMeta || {},
    component: () => import("/app/.app/pages/portal/planner/index.vue")
  },
  {
    name: "portal-postal-id___nl",
    path: "/nl/portal/postal/:id()",
    meta: _91id_93Pp7OIAFltEMeta || {},
    component: () => import("/app/.app/pages/portal/postal/[id].vue")
  },
  {
    name: "portal-postal-id___en",
    path: "/en/portal/postal/:id()",
    meta: _91id_93Pp7OIAFltEMeta || {},
    component: () => import("/app/.app/pages/portal/postal/[id].vue")
  },
  {
    name: "portal-postal-id___fr",
    path: "/fr/portal/postal/:id()",
    meta: _91id_93Pp7OIAFltEMeta || {},
    component: () => import("/app/.app/pages/portal/postal/[id].vue")
  },
  {
    name: "portal-postal___nl",
    path: "/nl/portal/postal",
    meta: indexjTmRZ23cHWMeta || {},
    component: () => import("/app/.app/pages/portal/postal/index.vue")
  },
  {
    name: "portal-postal___en",
    path: "/en/portal/postal",
    meta: indexjTmRZ23cHWMeta || {},
    component: () => import("/app/.app/pages/portal/postal/index.vue")
  },
  {
    name: "portal-postal___fr",
    path: "/fr/portal/postal",
    meta: indexjTmRZ23cHWMeta || {},
    component: () => import("/app/.app/pages/portal/postal/index.vue")
  },
  {
    name: "portal-postal-new___nl",
    path: "/nl/portal/postal/new",
    meta: newIWwRVwZNiXMeta || {},
    component: () => import("/app/.app/pages/portal/postal/new.vue")
  },
  {
    name: "portal-postal-new___en",
    path: "/en/portal/postal/new",
    meta: newIWwRVwZNiXMeta || {},
    component: () => import("/app/.app/pages/portal/postal/new.vue")
  },
  {
    name: "portal-postal-new___fr",
    path: "/fr/portal/postal/new",
    meta: newIWwRVwZNiXMeta || {},
    component: () => import("/app/.app/pages/portal/postal/new.vue")
  },
  {
    name: "portal-rides-id___nl",
    path: "/nl/portal/rides/:id()",
    meta: _91id_93ZaotP8mr0lMeta || {},
    component: () => import("/app/.app/pages/portal/rides/[id].vue")
  },
  {
    name: "portal-rides-id___en",
    path: "/en/portal/rides/:id()",
    meta: _91id_93ZaotP8mr0lMeta || {},
    component: () => import("/app/.app/pages/portal/rides/[id].vue")
  },
  {
    name: "portal-rides-id___fr",
    path: "/fr/portal/rides/:id()",
    meta: _91id_93ZaotP8mr0lMeta || {},
    component: () => import("/app/.app/pages/portal/rides/[id].vue")
  },
  {
    name: "portal-rides___nl",
    path: "/nl/portal/rides",
    meta: indexEf6LwPA1ypMeta || {},
    component: () => import("/app/.app/pages/portal/rides/index.vue")
  },
  {
    name: "portal-rides___en",
    path: "/en/portal/rides",
    meta: indexEf6LwPA1ypMeta || {},
    component: () => import("/app/.app/pages/portal/rides/index.vue")
  },
  {
    name: "portal-rides___fr",
    path: "/fr/portal/rides",
    meta: indexEf6LwPA1ypMeta || {},
    component: () => import("/app/.app/pages/portal/rides/index.vue")
  },
  {
    name: "portal-rides-new___nl",
    path: "/nl/portal/rides/new",
    meta: newoOOFWbRafMMeta || {},
    component: () => import("/app/.app/pages/portal/rides/new.vue")
  },
  {
    name: "portal-rides-new___en",
    path: "/en/portal/rides/new",
    meta: newoOOFWbRafMMeta || {},
    component: () => import("/app/.app/pages/portal/rides/new.vue")
  },
  {
    name: "portal-rides-new___fr",
    path: "/fr/portal/rides/new",
    meta: newoOOFWbRafMMeta || {},
    component: () => import("/app/.app/pages/portal/rides/new.vue")
  },
  {
    name: "portal-settings-tags___nl",
    path: "/nl/portal/settings/tags",
    meta: tags9HAoLF7gkoMeta || {},
    component: () => import("/app/.app/pages/portal/settings/tags.vue")
  },
  {
    name: "portal-settings-tags___en",
    path: "/en/portal/settings/tags",
    meta: tags9HAoLF7gkoMeta || {},
    component: () => import("/app/.app/pages/portal/settings/tags.vue")
  },
  {
    name: "portal-settings-tags___fr",
    path: "/fr/portal/settings/tags",
    meta: tags9HAoLF7gkoMeta || {},
    component: () => import("/app/.app/pages/portal/settings/tags.vue")
  },
  {
    name: "portal-statistics___nl",
    path: "/nl/portal/statistics",
    meta: statisticsXXLRAiCSY8Meta || {},
    component: () => import("/app/.app/pages/portal/statistics.vue")
  },
  {
    name: "portal-statistics___en",
    path: "/en/portal/statistics",
    meta: statisticsXXLRAiCSY8Meta || {},
    component: () => import("/app/.app/pages/portal/statistics.vue")
  },
  {
    name: "portal-statistics___fr",
    path: "/fr/portal/statistics",
    meta: statisticsXXLRAiCSY8Meta || {},
    component: () => import("/app/.app/pages/portal/statistics.vue")
  },
  {
    name: "portal-towtrucks-id___nl",
    path: "/nl/portal/towtrucks/:id()",
    meta: _91id_93FX8Mi5iTsVMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/[id].vue")
  },
  {
    name: "portal-towtrucks-id___en",
    path: "/en/portal/towtrucks/:id()",
    meta: _91id_93FX8Mi5iTsVMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/[id].vue")
  },
  {
    name: "portal-towtrucks-id___fr",
    path: "/fr/portal/towtrucks/:id()",
    meta: _91id_93FX8Mi5iTsVMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/[id].vue")
  },
  {
    name: "portal-towtrucks___nl",
    path: "/nl/portal/towtrucks",
    meta: indexO28js6ik5TMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/index.vue")
  },
  {
    name: "portal-towtrucks___en",
    path: "/en/portal/towtrucks",
    meta: indexO28js6ik5TMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/index.vue")
  },
  {
    name: "portal-towtrucks___fr",
    path: "/fr/portal/towtrucks",
    meta: indexO28js6ik5TMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/index.vue")
  },
  {
    name: "portal-towtrucks-new___nl",
    path: "/nl/portal/towtrucks/new",
    meta: newCmwphgNA3MMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/new.vue")
  },
  {
    name: "portal-towtrucks-new___en",
    path: "/en/portal/towtrucks/new",
    meta: newCmwphgNA3MMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/new.vue")
  },
  {
    name: "portal-towtrucks-new___fr",
    path: "/fr/portal/towtrucks/new",
    meta: newCmwphgNA3MMeta || {},
    component: () => import("/app/.app/pages/portal/towtrucks/new.vue")
  },
  {
    name: "portal-trailers-id___nl",
    path: "/nl/portal/trailers/:id()",
    meta: _91id_93bmaZG1xCipMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/[id].vue")
  },
  {
    name: "portal-trailers-id___en",
    path: "/en/portal/trailers/:id()",
    meta: _91id_93bmaZG1xCipMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/[id].vue")
  },
  {
    name: "portal-trailers-id___fr",
    path: "/fr/portal/trailers/:id()",
    meta: _91id_93bmaZG1xCipMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/[id].vue")
  },
  {
    name: "portal-trailers___nl",
    path: "/nl/portal/trailers",
    meta: indexjPX3FOAXvIMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/index.vue")
  },
  {
    name: "portal-trailers___en",
    path: "/en/portal/trailers",
    meta: indexjPX3FOAXvIMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/index.vue")
  },
  {
    name: "portal-trailers___fr",
    path: "/fr/portal/trailers",
    meta: indexjPX3FOAXvIMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/index.vue")
  },
  {
    name: "portal-trailers-new___nl",
    path: "/nl/portal/trailers/new",
    meta: newuZuUl5VtOjMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/new.vue")
  },
  {
    name: "portal-trailers-new___en",
    path: "/en/portal/trailers/new",
    meta: newuZuUl5VtOjMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/new.vue")
  },
  {
    name: "portal-trailers-new___fr",
    path: "/fr/portal/trailers/new",
    meta: newuZuUl5VtOjMeta || {},
    component: () => import("/app/.app/pages/portal/trailers/new.vue")
  },
  {
    name: "portal-transport___nl",
    path: "/nl/portal/transport",
    meta: indexzxoDtLIKuDMeta || {},
    component: () => import("/app/.app/pages/portal/transport/index.vue")
  },
  {
    name: "portal-transport___en",
    path: "/en/portal/transport",
    meta: indexzxoDtLIKuDMeta || {},
    component: () => import("/app/.app/pages/portal/transport/index.vue")
  },
  {
    name: "portal-transport___fr",
    path: "/fr/portal/transport",
    meta: indexzxoDtLIKuDMeta || {},
    component: () => import("/app/.app/pages/portal/transport/index.vue")
  },
  {
    name: "portal-users-id___nl",
    path: "/nl/portal/users/:id()",
    meta: _91id_93Tc2I0sxqPFMeta || {},
    component: () => import("/app/.app/pages/portal/users/[id].vue")
  },
  {
    name: "portal-users-id___en",
    path: "/en/portal/users/:id()",
    meta: _91id_93Tc2I0sxqPFMeta || {},
    component: () => import("/app/.app/pages/portal/users/[id].vue")
  },
  {
    name: "portal-users-id___fr",
    path: "/fr/portal/users/:id()",
    meta: _91id_93Tc2I0sxqPFMeta || {},
    component: () => import("/app/.app/pages/portal/users/[id].vue")
  },
  {
    name: "portal-users___nl",
    path: "/nl/portal/users",
    meta: indexeuzQPB7LNXMeta || {},
    component: () => import("/app/.app/pages/portal/users/index.vue")
  },
  {
    name: "portal-users___en",
    path: "/en/portal/users",
    meta: indexeuzQPB7LNXMeta || {},
    component: () => import("/app/.app/pages/portal/users/index.vue")
  },
  {
    name: "portal-users___fr",
    path: "/fr/portal/users",
    meta: indexeuzQPB7LNXMeta || {},
    component: () => import("/app/.app/pages/portal/users/index.vue")
  },
  {
    name: "portal-users-new___nl",
    path: "/nl/portal/users/new",
    meta: newLelSdEx4sLMeta || {},
    component: () => import("/app/.app/pages/portal/users/new.vue")
  },
  {
    name: "portal-users-new___en",
    path: "/en/portal/users/new",
    meta: newLelSdEx4sLMeta || {},
    component: () => import("/app/.app/pages/portal/users/new.vue")
  },
  {
    name: "portal-users-new___fr",
    path: "/fr/portal/users/new",
    meta: newLelSdEx4sLMeta || {},
    component: () => import("/app/.app/pages/portal/users/new.vue")
  },
  {
    name: "prices___nl",
    path: "/nl/prijzen",
    meta: pricesQi90KJorxuMeta || {},
    component: () => import("/app/.app/pages/prices.vue")
  },
  {
    name: "prices___en",
    path: "/en/prices",
    meta: pricesQi90KJorxuMeta || {},
    component: () => import("/app/.app/pages/prices.vue")
  },
  {
    name: "prices___fr",
    path: "/fr/prix",
    meta: pricesQi90KJorxuMeta || {},
    component: () => import("/app/.app/pages/prices.vue")
  },
  {
    name: _91id_93SDSACHecv7Meta?.name,
    path: "/nl/scheduler/:id()",
    component: () => import("/app/.app/pages/scheduler/[id].vue"),
    children: [
  {
    name: "scheduler-id-bob___nl",
    path: "bob",
    meta: bobR5ylcTAy2gMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/bob.vue")
  },
  {
    name: "scheduler-id___nl",
    path: "",
    meta: index33TqLcbgJ1Meta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/index.vue")
  },
  {
    name: "scheduler-id-proposal___nl",
    path: "proposal",
    meta: proposalHkTNv2pdXfMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/proposal.vue")
  },
  {
    name: "scheduler-id-success___nl",
    path: "success",
    meta: successiHupaQF8TuMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/success.vue")
  }
]
  },
  {
    name: _91id_93SDSACHecv7Meta?.name,
    path: "/en/scheduler/:id()",
    component: () => import("/app/.app/pages/scheduler/[id].vue"),
    children: [
  {
    name: "scheduler-id-bob___en",
    path: "bob",
    meta: bobR5ylcTAy2gMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/bob.vue")
  },
  {
    name: "scheduler-id___en",
    path: "",
    meta: index33TqLcbgJ1Meta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/index.vue")
  },
  {
    name: "scheduler-id-proposal___en",
    path: "proposal",
    meta: proposalHkTNv2pdXfMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/proposal.vue")
  },
  {
    name: "scheduler-id-success___en",
    path: "success",
    meta: successiHupaQF8TuMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/success.vue")
  }
]
  },
  {
    name: _91id_93SDSACHecv7Meta?.name,
    path: "/fr/scheduler/:id()",
    component: () => import("/app/.app/pages/scheduler/[id].vue"),
    children: [
  {
    name: "scheduler-id-bob___fr",
    path: "bob",
    meta: bobR5ylcTAy2gMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/bob.vue")
  },
  {
    name: "scheduler-id___fr",
    path: "",
    meta: index33TqLcbgJ1Meta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/index.vue")
  },
  {
    name: "scheduler-id-proposal___fr",
    path: "proposal",
    meta: proposalHkTNv2pdXfMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/proposal.vue")
  },
  {
    name: "scheduler-id-success___fr",
    path: "success",
    meta: successiHupaQF8TuMeta || {},
    component: () => import("/app/.app/pages/scheduler/[id]/success.vue")
  }
]
  },
  {
    name: "testing-auth___nl",
    path: "/nl/testing/auth",
    meta: authddXOoYqdewMeta || {},
    component: () => import("/app/.app/pages/testing/auth.vue")
  },
  {
    name: "testing-auth___en",
    path: "/en/testing/auth",
    meta: authddXOoYqdewMeta || {},
    component: () => import("/app/.app/pages/testing/auth.vue")
  },
  {
    name: "testing-auth___fr",
    path: "/fr/testing/auth",
    meta: authddXOoYqdewMeta || {},
    component: () => import("/app/.app/pages/testing/auth.vue")
  },
  {
    name: "testing-bob___nl",
    path: "/nl/testing/bob",
    meta: bobcsw8jbCOsDMeta || {},
    component: () => import("/app/.app/pages/testing/bob.vue")
  },
  {
    name: "testing-bob___en",
    path: "/en/testing/bob",
    meta: bobcsw8jbCOsDMeta || {},
    component: () => import("/app/.app/pages/testing/bob.vue")
  },
  {
    name: "testing-bob___fr",
    path: "/fr/testing/bob",
    meta: bobcsw8jbCOsDMeta || {},
    component: () => import("/app/.app/pages/testing/bob.vue")
  },
  {
    name: "testing-booking___nl",
    path: "/nl/testing/booking",
    meta: bookingnPeCGgjSdRMeta || {},
    component: () => import("/app/.app/pages/testing/booking.vue")
  },
  {
    name: "testing-booking___en",
    path: "/en/testing/booking",
    meta: bookingnPeCGgjSdRMeta || {},
    component: () => import("/app/.app/pages/testing/booking.vue")
  },
  {
    name: "testing-booking___fr",
    path: "/fr/testing/booking",
    meta: bookingnPeCGgjSdRMeta || {},
    component: () => import("/app/.app/pages/testing/booking.vue")
  },
  {
    name: "testing-bookingagency___nl",
    path: "/nl/testing/bookingagency",
    meta: bookingagencybfDxR3ooXhMeta || {},
    component: () => import("/app/.app/pages/testing/bookingagency.vue")
  },
  {
    name: "testing-bookingagency___en",
    path: "/en/testing/bookingagency",
    meta: bookingagencybfDxR3ooXhMeta || {},
    component: () => import("/app/.app/pages/testing/bookingagency.vue")
  },
  {
    name: "testing-bookingagency___fr",
    path: "/fr/testing/bookingagency",
    meta: bookingagencybfDxR3ooXhMeta || {},
    component: () => import("/app/.app/pages/testing/bookingagency.vue")
  },
  {
    name: "testing-calenderentry___nl",
    path: "/nl/testing/calenderentry",
    meta: calenderentryPyOvRF4So5Meta || {},
    component: () => import("/app/.app/pages/testing/calenderentry.vue")
  },
  {
    name: "testing-calenderentry___en",
    path: "/en/testing/calenderentry",
    meta: calenderentryPyOvRF4So5Meta || {},
    component: () => import("/app/.app/pages/testing/calenderentry.vue")
  },
  {
    name: "testing-calenderentry___fr",
    path: "/fr/testing/calenderentry",
    meta: calenderentryPyOvRF4So5Meta || {},
    component: () => import("/app/.app/pages/testing/calenderentry.vue")
  },
  {
    name: "testing-calenderentrytype___nl",
    path: "/nl/testing/calenderentrytype",
    meta: calenderentrytypeX3j6yigBSuMeta || {},
    component: () => import("/app/.app/pages/testing/calenderentrytype.vue")
  },
  {
    name: "testing-calenderentrytype___en",
    path: "/en/testing/calenderentrytype",
    meta: calenderentrytypeX3j6yigBSuMeta || {},
    component: () => import("/app/.app/pages/testing/calenderentrytype.vue")
  },
  {
    name: "testing-calenderentrytype___fr",
    path: "/fr/testing/calenderentrytype",
    meta: calenderentrytypeX3j6yigBSuMeta || {},
    component: () => import("/app/.app/pages/testing/calenderentrytype.vue")
  },
  {
    name: "testing-coupon___nl",
    path: "/nl/testing/coupon",
    meta: couponQCLUvFd6LuMeta || {},
    component: () => import("/app/.app/pages/testing/coupon.vue")
  },
  {
    name: "testing-coupon___en",
    path: "/en/testing/coupon",
    meta: couponQCLUvFd6LuMeta || {},
    component: () => import("/app/.app/pages/testing/coupon.vue")
  },
  {
    name: "testing-coupon___fr",
    path: "/fr/testing/coupon",
    meta: couponQCLUvFd6LuMeta || {},
    component: () => import("/app/.app/pages/testing/coupon.vue")
  },
  {
    name: "testing-damage___nl",
    path: "/nl/testing/damage",
    meta: damageHBxpSn47M5Meta || {},
    component: () => import("/app/.app/pages/testing/damage.vue")
  },
  {
    name: "testing-damage___en",
    path: "/en/testing/damage",
    meta: damageHBxpSn47M5Meta || {},
    component: () => import("/app/.app/pages/testing/damage.vue")
  },
  {
    name: "testing-damage___fr",
    path: "/fr/testing/damage",
    meta: damageHBxpSn47M5Meta || {},
    component: () => import("/app/.app/pages/testing/damage.vue")
  },
  {
    name: "testing-drinks___nl",
    path: "/nl/testing/drinks",
    meta: drinksq67it1OyaMMeta || {},
    component: () => import("/app/.app/pages/testing/drinks.vue")
  },
  {
    name: "testing-drinks___en",
    path: "/en/testing/drinks",
    meta: drinksq67it1OyaMMeta || {},
    component: () => import("/app/.app/pages/testing/drinks.vue")
  },
  {
    name: "testing-drinks___fr",
    path: "/fr/testing/drinks",
    meta: drinksq67it1OyaMMeta || {},
    component: () => import("/app/.app/pages/testing/drinks.vue")
  },
  {
    name: "testing-employee___nl",
    path: "/nl/testing/employee",
    meta: employeeVjiSxinSfuMeta || {},
    component: () => import("/app/.app/pages/testing/employee.vue")
  },
  {
    name: "testing-employee___en",
    path: "/en/testing/employee",
    meta: employeeVjiSxinSfuMeta || {},
    component: () => import("/app/.app/pages/testing/employee.vue")
  },
  {
    name: "testing-employee___fr",
    path: "/fr/testing/employee",
    meta: employeeVjiSxinSfuMeta || {},
    component: () => import("/app/.app/pages/testing/employee.vue")
  },
  {
    name: "testing-package___nl",
    path: "/nl/testing/package",
    meta: package2UHBzkBWFxMeta || {},
    component: () => import("/app/.app/pages/testing/package.vue")
  },
  {
    name: "testing-package___en",
    path: "/en/testing/package",
    meta: package2UHBzkBWFxMeta || {},
    component: () => import("/app/.app/pages/testing/package.vue")
  },
  {
    name: "testing-package___fr",
    path: "/fr/testing/package",
    meta: package2UHBzkBWFxMeta || {},
    component: () => import("/app/.app/pages/testing/package.vue")
  },
  {
    name: "testing-partybike___nl",
    path: "/nl/testing/partybike",
    meta: partybikeNxOnC4fjywMeta || {},
    component: () => import("/app/.app/pages/testing/partybike.vue")
  },
  {
    name: "testing-partybike___en",
    path: "/en/testing/partybike",
    meta: partybikeNxOnC4fjywMeta || {},
    component: () => import("/app/.app/pages/testing/partybike.vue")
  },
  {
    name: "testing-partybike___fr",
    path: "/fr/testing/partybike",
    meta: partybikeNxOnC4fjywMeta || {},
    component: () => import("/app/.app/pages/testing/partybike.vue")
  },
  {
    name: "testing-refueling___nl",
    path: "/nl/testing/refueling",
    meta: refuelingck3pGb3jCRMeta || {},
    component: () => import("/app/.app/pages/testing/refueling.vue")
  },
  {
    name: "testing-refueling___en",
    path: "/en/testing/refueling",
    meta: refuelingck3pGb3jCRMeta || {},
    component: () => import("/app/.app/pages/testing/refueling.vue")
  },
  {
    name: "testing-refueling___fr",
    path: "/fr/testing/refueling",
    meta: refuelingck3pGb3jCRMeta || {},
    component: () => import("/app/.app/pages/testing/refueling.vue")
  },
  {
    name: "testing-towtruck___nl",
    path: "/nl/testing/towtruck",
    meta: towtruckCY7NaXfPdIMeta || {},
    component: () => import("/app/.app/pages/testing/towtruck.vue")
  },
  {
    name: "testing-towtruck___en",
    path: "/en/testing/towtruck",
    meta: towtruckCY7NaXfPdIMeta || {},
    component: () => import("/app/.app/pages/testing/towtruck.vue")
  },
  {
    name: "testing-towtruck___fr",
    path: "/fr/testing/towtruck",
    meta: towtruckCY7NaXfPdIMeta || {},
    component: () => import("/app/.app/pages/testing/towtruck.vue")
  },
  {
    name: "testing-trailer___nl",
    path: "/nl/testing/trailer",
    meta: trailer7GCjg3z4GWMeta || {},
    component: () => import("/app/.app/pages/testing/trailer.vue")
  },
  {
    name: "testing-trailer___en",
    path: "/en/testing/trailer",
    meta: trailer7GCjg3z4GWMeta || {},
    component: () => import("/app/.app/pages/testing/trailer.vue")
  },
  {
    name: "testing-trailer___fr",
    path: "/fr/testing/trailer",
    meta: trailer7GCjg3z4GWMeta || {},
    component: () => import("/app/.app/pages/testing/trailer.vue")
  },
  {
    name: component_45stub02vfHGKSV9Meta?.name,
    path: "/sitemap.xml",
    component: component_45stub02vfHGKSV9
  }
]